import { render, staticRenderFns } from "./TheDigitalSignature.vue?vue&type=template&id=2f574b7c&scoped=true&"
import script from "./TheDigitalSignature.vue?vue&type=script&lang=js&"
export * from "./TheDigitalSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f574b7c",
  null
  
)

export default component.exports